
import { defineComponent, PropType } from 'vue';
import ProductSpecs from '@/b2c/shared/product/ui/ProductSpecs.vue';
import { PersonalOfferRegularItemModel } from '@/b2c/shared/api/server-apis';
import AddOfferItemToBasket from '@/b2c/offers/ui/AddOfferItemToBasket.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import RegularItemPrice from '@/b2c/offers/ui/helpers/RegularItemPrice.vue';
import RegularItemImage from '@/b2c/offers/ui/helpers/RegularItemImage.vue';
import RegularItemQuantity from '@/b2c/offers/ui/helpers/RegularItemQuantity.vue';

export default defineComponent({
    name: 'RegularItem',
    components: {
        RegularItemQuantity,
        RegularItemImage,
        RegularItemPrice,
        AddOfferItemToBasket,
        ProductSpecs,
    },
    props: {
        item: {
            type: Object as PropType<PersonalOfferRegularItemModel>,
            required: true,
        },
    },
    setup() {
        const labels = useBlockLabels();
        return {
            labels,
        };
    },
});
